import React, { useState } from "react";
import { Box, Paper, Tab, Tabs, Typography } from "@mui/material";
import { EegDataRecord, EEGMetric, EEGRecording } from "../types";
import { BandState } from "./BandState";
import { RegionalState } from "./RegionalState";
import { useAllEegData } from "../utils/useEeegData";


type MetricDetailsTabsProps = {
    metrics: Array<EEGMetric>;
    showDataInTable: (title: string, records: Array<EegDataRecord>) => void;
    firstEEG: EEGRecording;
    secondEEG?: EEGRecording;
    allEegData: ReturnType<typeof useAllEegData>;
};

export const MetricDetailsTabs = ({ metrics, showDataInTable, firstEEG, secondEEG, allEegData }: MetricDetailsTabsProps) => {
    const [value, setValue] = useState(0);

    if (metrics.length === 0) {
        return null;
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const selectedMetric = metrics[value];

    return (
        <Paper sx={{ mb: 4, maxWidth: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="metric details tabs"
                    TabIndicatorProps={{ sx: { height: 3 } }}
                >
                    {metrics.map((metric) => (
                        <Tab label={metric.name_external} key={metric.id} sx={{ fontWeight: 600 }} />
                    ))}
                </Tabs>
            </Box>
            <Box sx={{ p: 3, backgroundColor: "#fdfdfd", mt: 4 }}>
                <Typography variant="h6" sx={{ color: "text.secondary", fontWeight: 600, mb: 2 }}>
                    Frequency Bands
                </Typography>
                <BandState 
                    metric={selectedMetric} 
                    showDataInTable={showDataInTable} 
                    firstEEG={firstEEG} 
                    secondEEG={secondEEG}
                    allEegData={allEegData}
                />
            </Box>
            <Box sx={{ p: 3, backgroundColor: "#fdfdfd" }}>
                <Typography variant="h6" sx={{ color: "text.secondary", fontWeight: 600, mb: 2 }}>
                    Regional Brain Areas
                </Typography>
                <RegionalState
                    metric={selectedMetric}
                    showDataInTable={showDataInTable}
                    firstEEG={firstEEG}
                    secondEEG={secondEEG}
                    allEegData={allEegData}
                />
            </Box>
        </Paper>
    );
};
